import {ListEditor} from "../../components/list-editor";
import React from "react";
import { array, string, object } from 'yup';
import {
    SiteStructureType, SiteStructureTypeQueryQuery,
    useSiteStructureTypeQueryQuery, useUpdateSiteStructureTypeMutation
} from "../../generated/graphql";
import {useLocation} from "react-router";
import {uniqueId} from "../../utils";


const columns = [{
    header: 'Name',
    accessor: 'name',
    dataType:'text'
}
];

function newRow(): SiteStructureType {
    return ({
        id: uniqueId(),
        name: ''
    })
}

const schema =  array().of(object().shape({
        name: string().min(1)
}));


function getValues(data:SiteStructureTypeQueryQuery) {
    return data?.siteStructureTypes;
}

const SiteStructureTypes = ()=>{
    const query = useSiteStructureTypeQueryQuery();
    const [mutation,mutationResult] = useUpdateSiteStructureTypeMutation();
    const url = useLocation().pathname;
    return (
        <ListEditor
           columns={columns}
           validationSchema={schema}
           title="Site Structures"
           permission="sites"
           query={query}
           mutation={mutation}
           saveResult={mutationResult}
           newRow={newRow}
           newRowLabel="Add Site Structure Type"
           baseUrl={url}
           className="site-structure-types"
           getValues={getValues}
        />);
}

export default SiteStructureTypes;
